import { Tooltip, TooltipContent, TooltipTrigger } from '@workspace/ui/components/tooltip'
import { Info } from 'lucide-react'

/**
 * Small info icon (ⓘ) that shows a tooltip on hover/focus.
 * Used next to metric labels to explain what they mean.
 */
export function MetricTooltip({ text }: { text: string }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          className="inline-flex size-3.5 shrink-0 items-center justify-center text-muted-foreground/60 transition-colors hover:text-muted-foreground"
        >
          <Info className="size-3" />
        </button>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-64">
        {text}
      </TooltipContent>
    </Tooltip>
  )
}
